import { useEffect, useRef, useState } from 'react';
import { SnackbarState, useSnackbarStore } from '../../../stores/Snackbar.store';
import { useLoadingStatusSnackbar } from './useLoadingStatusSnackbar';

const MIN_LOADING_NOTICE_MS = 1000;

export const useTeceoSnackbar = () => {
  useLoadingStatusSnackbar();

  const { open, state, close } = useSnackbarStore();
  const [notice, setNotice] = useState<SnackbarState>(state);
  const loadingShownAtRef = useRef(0);

  useEffect(() => {
    if (state.loading) {
      loadingShownAtRef.current = Date.now();
      setNotice(state);
      return;
    }

    const remainingMs = MIN_LOADING_NOTICE_MS - (Date.now() - loadingShownAtRef.current);

    if (remainingMs <= 0) {
      setNotice(state);
      return;
    }

    const timer = setTimeout(() => setNotice(state), remainingMs);

    return () => clearTimeout(timer);
  }, [state]);

  return { open, notice, close };
};
